export default [
  {
    path: '/config/profiles',
    name: 'profiles',
    component: () => import('@/pages/Profiles/profilesList.vue'),
    meta: { requiresAuth: true, requiresSuperAdmin: true }
  },
  {
    path: '/config/profiles/:profileId/permissions',
    name: 'profile-permissions',
    props: true,
    component: () => import('@/pages/Profiles/profilePermissions.vue'),
    meta: { requiresAuth: true, requiresSuperAdmin: true }
  }
]
